/*
 * @Author: Chao Yang
 * @Date: 2021-11-11 07:49:12
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-11-11 07:50:50
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseProxy } from '../base.proxy';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class BrandProxy extends BaseProxy {
  constructor(_http: HttpClient) {
    super(_http);
  }

  get(): Observable<any> {
    if (environment.feature.newApi === false) {
      return this._http.get<any>('/ip/api/brand');
    } else {
      return this._http.get<any>('/ip-api/api/tenant');
    }
  }

  switch(brand: string): Observable<any> {
    if (environment.feature.newApi === false) {
      return this._http.put<any>(`/ip/api/brand/${brand}`, undefined);
    } else {
      return this._http.put<any>(`/ip-api/api/tenant/${brand}`, undefined);
    }
  }
}
